module.exports = __webpack_public_path__ + "media/src/img/slick-left-f828eece88560477ca9d35ddd18f259f.svg";